<template>
  <div>
    <v-dialog v-model="show" :loading="loading" max-width="550px">
      <v-card>
        <v-card-title>
          <span class="headline">Notifications</span>
          <v-btn style="position: absolute; right: 20px" icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="px-4 float-left width-full">
          <transition-group name="list">
            <div class="record-card pa-4" v-for="record in notifications" :key="record._id">
              <Message :record="record.id" :active="record.read" :id="record._id" @read="readed" />
              <div v-if="record._images" class="width-full float-left pt-1 pl-5">
                <vue-picture-swipe small :items="record._images"></vue-picture-swipe>
              </div>
            </div>
          </transition-group>
        </div>
        <div v-if="notifications.length == 0" class="px-4 mb-4 width-full text-center">
          You have no notifications...
        </div>

        <v-card-actions>
          <div class="px-4 width-full">
          <v-spacer></v-spacer>
          <v-btn v-if="notifications.length == 10" color="blue darken-1" text>More...</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Message from "./message.vue";
import axios from "axios";
export default {
  components: {
    Message
  },
  props: ["show"],
  data() {
    return {
      loading: false,
      notifications: []
    };
  },
  watch: {
    show(val) {
      val && this.newOpen();
      !val && this.$emit("close", false);
    }
  },
  mounted() {
    this.$socket.emit("auth", this.$store.state.userData._id);
    setInterval(() => {
      this.$socket.emit("auth", this.$store.state.userData._id);
    }, 10000);
  },
  methods: {
    readed(val){
      axios
        .post("https://tradeinpool.com:3001/api/update/notifications/",{method: "disable",id: val})
        .then(() => {});
      this.notifications.forEach((notify,index) =>{
        if(notify._id == val){
          this.notifications[index].read = true
        }
      })
    },
    resetNotifications() {
      axios
        .post("https://tradeinpool.com:3001/api/update/notifications/",{method: "reset"})
        .then(() => {
          setTimeout(() => {
            this.$store.state.userData.notifications = 0;
          }, 1000);
        });
    },
    getNotifications() {
      axios
        .post("https://tradeinpool.com:3001/api/request/notifications/")
        .then(response => {
          this.notifications = response.data;
          this.resetNotifications();
        });
    },
    newOpen() {
      //this.$socket.emit('auth', this.$store.state.userData.token)
      //if (this.notifications.length == 0) {
        this.getNotifications();
      //} else {
      //  this.resetNotifications();
      //}
    }
  },
  sockets: {
    NOTIFICATION: function(data) {
      this.notifications.unshift(data)
      this.$store.state.userData.notifications += 1;
    }
  }
};
</script>

<style>
</style>